import * as localizationsActions from './actions'
import _ from 'lodash'
import { langs } from '../config'
import { Record } from '../transit'


const State = Record({
  all: [],
  byKey: {},
  current: null,
}, 'localizations')

const localizationsReducer = (state = new State(), action) => {
  switch (action.type) {
    case localizationsActions.LOCALIZATION_LOAD_SUCCESS:
    case localizationsActions.LOCALIZATION_ADD_SUCCESS: {
      return state.set('current', action.payload.data)
    }
    case localizationsActions.LOCALIZATIONS_LOAD_SUCCESS: {
      const localizations = action.payload.data
      const localizationsByKey = {}

      const langsTemplate = {}
      langs.forEach(lang => {
        langsTemplate[lang.key] = ''
      })

      localizations.forEach(l => {
        if (localizationsByKey[l.id]) {
          localizationsByKey[l.id][l.language] = l.message
        } else {
          localizationsByKey[l.id] = {}
          Object.assign(localizationsByKey[l.id], langsTemplate)
          localizationsByKey[l.id][l.language] = l.message
        }
      })

      return state.set('all', localizations)
                  .set('byKey', localizationsByKey)
    }
    case localizationsActions.LOCALIZATIONS_CLEAR: {
      return state.set('all', [])
    }
    case localizationsActions.LOCALIZATION_CLEAR: {
      return state.set('current', null)
    }
    default: {
      return state
    }
  }
}

export default localizationsReducer



// WEBPACK FOOTER //
// ./src/common/localizations/reducer.js